import React from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import { FormattedMessage } from "react-intl";
import { handleBlankValue } from "../../../commons/CommonUtils";

const AttributeView = (props) => {
    return (
        <Column>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.container.attribute_label" defaultMessage="Label"/></Text>
                <Text type="b200">{handleBlankValue(props.data.containerLabel)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.container.attribute_type" defaultMessage="Type"/></Text>
                <Text type="b200">{handleBlankValue(props.data.containerType)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.container.attribute_color" defaultMessage="Color"/></Text>
                <Text type="b200">{handleBlankValue(props.data.containerColor)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.container.attribute_scannableId" defaultMessage="ScannableId"/></Text>
                <Text type="b200">{handleBlankValue(props.data.scannableId)}</Text>
            </Row>
        </Column>     
    )
 }

export default AttributeView;


// WEBPACK FOOTER //
// ./src/components/detailPages/containerDetails/AttributeView.js